import script from "./Teacher.vue?vue&type=script&setup=true&lang=js"
export * from "./Teacher.vue?vue&type=script&setup=true&lang=js"

import "./Teacher.vue?vue&type=style&index=0&id=4ae0b767&lang=css"

const __exports__ = script;

export default __exports__